import gql from 'graphql-tag';

export default gql`
  mutation addOrUpdateCard($cardId: String) {
    accountAddOrUpdateCard(cardId: $cardId) {
      id
      last4
      brand
      exp_month
      exp_year
      address_zip
      customer
    }
  }
`;
